package com.example.readingnotes.domain.usecase

import com.example.readingnotes.domain.model.Post
import com.example.readingnotes.domain.repository.PostRepository
import com.example.readingnotes.util.Result

class LoadPostDetailUseCase(
    private val postRepository: PostRepository,
) {
    suspend operator fun invoke(postId: Int): Result<Post> = postRepository.getPost(postId)
}
